import { render } from "./p-advanced-select.vue?vue&type=template&id=3c2980c0&scoped=true"
import script from "./p-advanced-select.vue?vue&type=script&lang=js"
export * from "./p-advanced-select.vue?vue&type=script&lang=js"

import "./p-advanced-select.vue?vue&type=style&index=0&id=3c2980c0&scoped=true&lang=scss"
import "./p-advanced-select.vue?vue&type=style&index=1&id=3c2980c0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2980c0"]])

export default __exports__